import debounce from './fn__debounce.mjs';
import accessCssVariable from './fn__accessCssVariable.mjs';

/* global jQuery */
void (function themeStart($) {
	// Global variables
	const $mainNav = $('#mainNav');
	const $navToggle = $('#navToggle');
	let navIsMobile;
	let navWasMobile;
	let navIsHidden;
	const mobileZIndex = 100;
	const debounceWaitTime = 250;

	function toggleNav() {
		// Find initial nav state
		navIsHidden = $mainNav.attr('aria-hidden').toString() === 'true';

		// Find what the current state of nav should be
		let newNavState;
		if (navIsHidden) {
			newNavState = {
				label: 'Hide Menu',
				expanded: true,
				hidden: false,
			};
		} else {
			newNavState = {
				label: 'Show Menu',
				expanded: false,
				hidden: true,
			};
		}

		// Updating new main nav state
		navIsHidden = !navIsHidden;
		$navToggle.attr({
			'aria-label': newNavState.label,
			'aria-expanded': newNavState.expanded,
		});
		$mainNav.attr({
			'aria-hidden': newNavState.hidden,
			'data-current-level': 0,
		});

		// Hide all open menus
		$mainNav
			.find('.menu[aria-hidden="false"]')
			.attr({ 'aria-hidden': true });
	}

	// On page load...
	$(document).ready(() => {
		if ($mainNav.length === 0) {
			return;
		}

		// Find initial navigation state
		navIsMobile =
			accessCssVariable($mainNav, '--nav-is-mobile').toString() ===
			'true';

		// Fallback nav state check for browsers that don't support CSS Variables
		if (navIsMobile === undefined) {
			navIsMobile =
				parseInt(accessCssVariable($mainNav, 'z-index'), 10) ===
				mobileZIndex;
		}

		// If navigation is in desktop view, make navigation accessible
		if (!navIsMobile) {
			toggleNav();
		}
	});

	// When clicking the main nav toggle button...
	$navToggle.on('click', event => {
		event.preventDefault();

		// Update nav state
		navIsMobile = true;
		navWasMobile = true;
		toggleNav();
	});

	// When clicking a link in the main nav...
	$mainNav.on('click', '.menu-link', event => {
		if (navIsMobile) {
			// Find the clicked link, menu level of the clicked link, and the menu that the link is linking to
			const $menuLink = $(event.target).closest('.menu-link');
			const linkLevel = $menuLink.attr('data-level');
			const linkMenuId = $menuLink.attr('data-page');
			const $activeSubMenu = $(`.menu[data-page="${linkMenuId}"]`);
			const menuLinkIsParent = $menuLink.hasClass('menu-link__parent');

			if (menuLinkIsParent) {
				event.preventDefault();

				// Find the initial nav state of the linked menu
				const subMenuHidden =
					$activeSubMenu.attr('aria-hidden').toString() === 'true';

				// Update the active menu level of the main nav
				$mainNav.attr({ 'data-current-level': linkLevel });

				// Update the active submenu's visibility
				$activeSubMenu.attr({
					'aria-hidden': !subMenuHidden,
				});
			}
		}
	});

	if ($mainNav.length > 0) {
		// On window resize...
		$(window).on(
			'resize',
			debounce(() => {
				// Find initial nav state
				navIsHidden =
					$mainNav.attr('aria-hidden').toString() === 'true';
				const navVariable = accessCssVariable(
					$mainNav,
					'--nav-is-mobile'
				);

				// Check to see if fallback is needed, otherwise update nav state
				if (!navVariable) {
					navIsMobile =
						parseInt(accessCssVariable($mainNav, 'z-index'), 10) ===
						mobileZIndex;
				} else {
					navIsMobile = navVariable.toString() === 'true';
				}

				// Update nav with proper state
				if (!navIsMobile) {
					if (navWasMobile || navIsHidden) {
						toggleNav();
					}
					$mainNav
						.find('.menu__submenu')
						.attr('aria-hidden', 'false');
					navWasMobile = false;
				} else {
					if (!navWasMobile && !navIsHidden) {
						toggleNav();
					}
					navWasMobile = true;
				}
			}, debounceWaitTime)
		);
	}

	// Find FAQs on the page
	const $faqContainers = $('.faq--question-group');
	// With each FAQ container...
	$faqContainers.each((index, faq) => {
		const $faq = $(faq);
		let lastQuestionId;

		// On page load...
		$(document).ready(() => {
			// Set intial height based on open answer
			const initialOpenQuestion = $faq
				.find('.faq--question[aria-expanded="true"]')
				.attr('data-question');
			const $currentAnswer = $faq.find(
				`.faq--answer[data-question=${initialOpenQuestion}]`
			);
			$faq.css('min-height', $currentAnswer.outerHeight());

			// Update view state
			lastQuestionId = initialOpenQuestion;
		});

		// When clicking FAQ question...
		$faq.on('click', '.faq--question', event => {
			// Find question state and associated answer state
			const $faqQuestions = $faq.find('.faq--question');
			const $faqAnswers = $faq.find('.faq--answer');
			const $currentQuestion = $(event.target).closest('.faq--question');
			const currentQuestionId = $currentQuestion.attr('data-question');
			const currentQuestionExpanded =
				$currentQuestion.attr('aria-expanded').toString() === 'true';
			const $currentAnswer = $faqAnswers.filter(
				`[data-question=${currentQuestionId}]`
			);
			const currentMinHeight = $currentAnswer.outerHeight();

			// Toggle questions and answers
			$faqQuestions
				.attr({
					'aria-expanded': false,
				})
				.filter($currentQuestion)
				.attr({
					'aria-expanded': !currentQuestionExpanded,
				});
			$faqAnswers
				.attr({
					'aria-hidden': true,
				})
				.filter($currentAnswer)
				.attr({
					'aria-hidden': currentQuestionExpanded,
				});

			// If the current question is the same as the last one that was clicked...
			if (lastQuestionId === currentQuestionId) {
				// If it's open, close it... Or if it's closed, open it
				if (currentQuestionExpanded) {
					$faq.css('min-height', 0);
				} else {
					$faq.css('min-height', currentMinHeight);
				}
			} else {
				// Otherwise, the current question is a new question so set it's height as the current height
				$faq.css('min-height', currentMinHeight);
			}

			lastQuestionId = currentQuestionId;
		});
	});

	const $userToggle = $('.user--toggle');
	const $userDropdown = $('.user--dropdown');

	// When clicking the login toggle...
	$userToggle.on('click', event => {
		event.preventDefault();

		// Check initial state of user dropdown
		const userPaneIsHidden =
			$userDropdown.attr('aria-hidden').toString() === 'true';

		// Update new dropdown state
		$userDropdown.attr({ 'aria-hidden': !userPaneIsHidden });
		$userToggle.attr({ 'aria-expanded': userPaneIsHidden });
	});

	// Hide Ad-Butler if AdsBlocked cookie is set
	window.onload = function() {
		if (document.cookie.includes('AdsBlocked=true;')) {
			const adBanner = document.querySelector('div.Ad-Butler');
			adBanner.style.display = 'none';
		}
	};
})(jQuery);
